// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:34:52

export default {
  "id": "snake-game-1",
  "slug": "snake-game-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/22e69354d0e042d29b23079a40b851f6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/22e69354d0e042d29b23079a40b851f6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Snake Puzzle 3D",
      "description": "Get ready to unravel a tangled knot of snakes to solve this puzzle! ?? Dive into the world of puzzle-solving games to become the legendary tangle master 3D! ??\n\nKnock-knot! Who’s there? Riddle. Riddle who? Riddle me this: how do you unravel a twisted tangle of serpents? With your sharp puzzle-solving skills! ? Welcome to Snake Knot: Sort Puzzle Game where your logic and gaming skills will be tested! Sort serpents to unknot every twisted tangle and free every color snake! ",
      "instructions": "Use mouse to move the snake",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "snake"
      ]
    },
    "zh-CN": {
      "title": "3D蛇形拼图",
      "description": "准备好解开一团乱麻的蛇来解这个谜题！？ 沉浸在解谜游戏的世界中，成为传奇的缠结大师3D！？\n\n敲-结！谁在那里？谜语。猜谜语是谁？猜猜看：你怎么解开扭曲的蛇团？用你敏锐的解谜技能！？ 欢迎来到蛇结：排序谜题游戏，在这里你的逻辑和游戏技巧将被考验！对蛇进行排序，解开每一个扭曲的结，释放每种颜色的蛇！",
      "instructions": "使用鼠标移动蛇",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1人玩家",
        "蛇"
      ]
    },
    "zh-TW": {
      "title": "蛇盤遊戲 3D",
      "description": "準備解開一個纏繞的蛇結謎題！?? 溝通進入解謎遊戲的世界，成為傳說中的纏結大師3D！??\n\n敲結！誰在那裡？謎題。謎題誰？這個謎題：如何解開一個纏繞的蛇結？用你鋒利的解謎技巧！??歡迎來到蛇結：整理謎題遊戲，你的邏輯和遊戲技巧將受到挑戰！整理蛇群以解開每一個纏繞的結，釋放每一種顏色的蛇！",
      "instructions": "使用滑鼠移動蛇",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "蛇"
      ]
    },
    "zh-HK": {
      "title": "蛇盤遊戲3D",
      "description": "準備好解開一個纏繞的蛇結謎題！? 溝進解謎遊戲的世界，成為傳說中的纏結大師3D！? ?? 敲結！誰在那裡？謎題。誰的謎題？這個謎題：你是如何解開一個纏繞的蛇結？用你鋒利的解謎技巧！? 歡迎來到蛇結：排序謎題遊戲，你的邏輯和遊戲技巧將受到挑戰！整理蛇群，解開每一個纏繞的結，釋放每一種顏色的蛇！",
      "instructions": "使用滑鼠移動蛇隻",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人遊戲",
        "蛇遊戲"
      ]
    },
    "ja": {
      "title": "3Dスネークパズル",
      "description": "この謎を解くために、蛇の絡み合ったノットを解き明かそう！？パズル解きゲームの世界に飛び込み、伝説の絡みマスター3Dに輝け！？\n\nノックノック！誰やねん？謎。どの謎やねん？これを聞いて：ねじれて絡み合った蛇の絡みを解く方法は何だ？あなたの鋭いパズル解きのスキルで！？\n\n「Snake Knot: Sort Puzzle Game」へようこそ！あなたの論理とゲームスキルが試される！蛇を整え、ねじれて絡み合った絡みを解き、色々な蛇を解放せよ！",
      "instructions": "マウスを使用して蛇を動かす",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "スネーク"
      ]
    },
    "ko": {
      "title": "3D 뱀 퍼즐",
      "description": "준비하세요! 이 퍼즐을 해결하기 위해 뱀의 복잡한 복도를 풀어보세요! ?? 퍼즐 해결 게임의 세계로 뛰어들어, 전설적인 복도 마스터 3D가 되세요! ??\n\n끈끈! 누구세요? 판타지. 판타지 누구? 이 판타지를 해결해 보세요: 뱀의 복잡한 복도를 풀어보세요? 뛰어난 퍼즐 해결 능력으로! ? 스네이크 노트: 정렬 퍼즐 게임에 오신 것을 환영합니다! 뱀을 정렬하여 모든 복잡한 복도를 풀고 모든 색상의 뱀을 آزاد하게 하세요!",
      "instructions": "뱀을 이동시키려면 마우스를 사용하세요",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "뱀"
      ]
    },
    "fr": {
      "title": "Snake Puzzle 3D\nPuzzle Snake 3D",
      "description": "Préparez-vous à dénouer un nœud enchevêtré de serpents pour résoudre ce puzzle ! ?? Plongez dans le monde des jeux de résolution de puzzles pour devenir le maître légendaire du nœud 3D ! ??\n\nClou-clou ! Qui êtes-vous ? Puzzle. Puzzle qui ? Puzzle-moi ceci : comment dénouer un nœud enchevêtré de serpents ? Avec vos compétences aiguës en résolution de puzzles ! ? Bienvenue dans Snake Knot : Jeu de Puzzle de Dénouage où votre logique et vos compétences en jeu seront testées ! Triagez les serpents pour dénouer chaque nœud tordu et libérez chaque serpent de couleur !",
      "instructions": "Utilisez la souris pour déplacer le serpent",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "serpent"
      ]
    }
  }
};
